import React from "react";

export function Spinner({ size = 16 }: { size?: number }) {
  return (
    <span
      className="inline-block rounded-full animate-spin"
      style={{
        width: size,
        height: size,
        border: "2px solid var(--c-border)",
        borderTopColor: "var(--c-primary)",
      }}
    />
  );
}
